import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BankCodes } from "../../models/polymer/BankCodes.model";
import { BASEURL_POLYMER, SUB_PATH_BASIC } from "../../utils/api";
import { CoveringRole } from "../../models/polymer/CoveringRole.model";

interface QueryParams {
  singpass_token: string;
  roleNrics: string[];
}

export const coveredRolesApi = createApi({
  reducerPath: "coveredRolesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Request-Method", "GET");
      headers.set("X-Content-Type-Options", "nosniff");
    },
  }),
  endpoints: (builder) => ({
    getCoveredRoles: builder.query<CoveringRole[], QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "POST",
        url: `${SUB_PATH_BASIC}/api/v1/hdb/covered-roles`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`,
        },
        body: queryParams.roleNrics
      }),
      keepUnusedDataFor: 1,
    }),
  }),
});

export const { useGetCoveredRolesQuery } = coveredRolesApi;
